export default "__VITE_ASSET__296230b5__"